import { drilldownData, ModuleFields } from "~/Utils/drilldownData";

const mapFields = (data: ModuleFields[]) => {
  return data.map((field) => ({
    name: field.name,
    type: field.formType,
    label: field.fieldName,
    fieldName: field.fieldName,
    fieldValue: field.fieldValue,
    placeholder: field.placeholder,
    validation: field.validation,
    className: field.className,
    usedFileType: field.usedFileType,
    options: field.options,
    loadOptions: field.loadOptions,
    editable: field.editable,
    hidden: field.hidden,
    note: field.note,
    futureDateRestriction: field.futureDateRestriction,
    dynamicFormType: field.dynamicFormType,
    rowConfig: field.rowConfig,
    imageDimension: field.imageDimension,
    openUpload: field.openUpload,
    uploadTrigger: field.uploadTrigger,
    disabledPreviousDateTime: field.disabledPreviousDateTime,
    showField: field.showField,
  }));
};

export const fields: any = {
  privacyPolicyTabOne: mapFields(drilldownData["privacyPolicyTabOne"]),

  myAirportsPrivacyPolicy: mapFields(drilldownData["myAirportsPrivacyPolicy"]),
  TabOneData: mapFields(drilldownData["TabOneData"]),
};
